import _ from 'lodash'

export default {
    toTop () {
        window.scrollTop = 0

        _.each(document.querySelectorAll('.scrolls-to-top'), el => {
            el.scrollTop = 0
        })
    }
}
